export default __webpack_public_path__ + "static/media/7.9a7c2772.png";